import { render, staticRenderFns } from "./HomepageTitle.vue?vue&type=template&id=00498ec0"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fref133%2Fpcnweb%2Ffrontend%2Fsrc%2Fcomponents%2FHomepageTitle.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports